import { create } from 'zustand';

// Full-screen spinner used to mask the brief render between an auth-store
// update (e.g. refreshAuth flipping account_status) and a route change
// triggered in the same async chain. Without it React 19 commits the
// "logged-in but not yet navigated" intermediate state, causing a flicker.

type State = {
  visible: boolean;
  show: (ms?: number) => void;
  hide: () => void;
};

let timer: ReturnType<typeof setTimeout> | null = null;

function clearTimer(): void {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

export const useTransitionOverlay = create<State>((set) => ({
  visible: false,
  show: (ms = 800) => {
    clearTimer();
    set({ visible: true });
    timer = setTimeout(() => {
      set({ visible: false });
      timer = null;
    }, ms);
  },
  hide: () => {
    clearTimer();
    set({ visible: false });
  },
}));
